import React, { useContext } from 'react'
import { useIntl } from 'react-intl'
import { PrelevementContext } from '../../PrelevementContext'
import PrelevementPersonalInfoForm from './PrelevementPersonalInfoForm'
import { PersonalPrelevementInfoModel } from '../../../profileModel'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../reducers'
import { isEmailOk } from '../../../../../utils/formUtils'
import { saveInteractions } from '../../../../gtm/utils/gtmCallback'

interface AcceptingProps {
    error?: string,
    setError: (error?: string) => void
}

type PrelevementPersonalInfoProps = AcceptingProps

const PrelevementPersonalInfo: React.FC<PrelevementPersonalInfoProps> =
    ({
        error,
        setError
    }) => {
    const { prelevement, userDetails, setPersonalInfo, nextStep } = useContext(PrelevementContext)
    const user = useSelector((state: RootState) => state.user)
    const intl = useIntl()
    const onSubmit = (values: PersonalPrelevementInfoModel) => {
        setPersonalInfo(values)
        setError(undefined)

        saveInteractions(
            {
                category: 'Mes Services',
                action: 'Souscrire en ligne',
                label: 'Mes Services::Souscrire en ligne::etape1::ok'
            }
        )

        nextStep()
    }

    const validate = (values: PersonalPrelevementInfoModel) => {
        const errors: any = {}

        if (!values.lastname) {
            errors.lastname = intl.formatMessage(
                {
                    id: 'global.errors.required',
                    defaultMessage: 'Requis*',
                    description: 'Required message'
                }
            )
        }
        if (!values.firstname) {
            errors.firstname = intl.formatMessage(
                {
                    id: 'global.errors.required',
                    defaultMessage: 'Requis*',
                    description: 'Required message'
                }
            )
        }
        if (!values.street) {
            errors.street = intl.formatMessage(
                {
                    id: 'global.errors.required',
                    defaultMessage: 'Requis*',
                    description: 'Required message'
                }
            )
        }
        if (!values.postalCode) {
            errors.postalCode = intl.formatMessage(
                {
                    id: 'global.errors.required',
                    defaultMessage: 'Requis*',
                    description: 'Required message'
                }
            )
        }
        if (!values.city) {
            errors.city = intl.formatMessage(
                {
                    id: 'global.errors.required',
                    defaultMessage: 'Requis*',
                    description: 'Required message'
                }
            )
        }
        if (!values.country) {
            errors.country = intl.formatMessage(
                {
                    id: 'global.errors.required',
                    defaultMessage: 'Requis*',
                    description: 'Required message'
                }
            )
        }
        if (!values.email) {
            errors.email = intl.formatMessage(
                {
                    id: 'global.errors.required',
                    defaultMessage: 'Requis*',
                    description: 'Required message'
                }
            )
        } else if (!isEmailOk(values.email)) {
            errors.email = intl.formatMessage(
                {
                    id: 'global.errors.formatEmail',
                    defaultMessage: 'Format du courriel incorrect',
                    description: 'Format mail error'
                }
            )
        }
        if (!values.phone) {
            errors.phone = intl.formatMessage(
                {
                    id: 'global.errors.required',
                    defaultMessage: 'Requis*',
                    description: 'Required message'
                }
            )
        }

        return errors
    }

    const contract = prelevement.propertyConcerned[0]
    const personalInfo = prelevement.personalInfo

    return (
        <PrelevementPersonalInfoForm
            onSubmit={onSubmit}
            validate={validate}
            initialValues={{
                firstname: personalInfo.firstname || user.firstname,
                lastname: personalInfo.lastname || user.lastname,
                email: personalInfo.email || userDetails.email,
                phone: personalInfo.phone || userDetails.phone || '',
                street: personalInfo.street || contract.address,
                postalCode: personalInfo.postalCode || contract.postalCode,
                city: personalInfo.city || contract.city,
                country: personalInfo.country || ''
            }}
            error={error}
        />
    )
}


export default PrelevementPersonalInfo